import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Instagram, MessageCircle } from "lucide-react";
import { COMPANY, buildWhatsAppUrl, callUrl, mailUrl } from "@/lib/config";
import { SERVICES, SERVICE_AREAS_TOP20 } from "@/lib/data";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_shifting-kerala/artifacts/4z3cmwaw_KAKAKA%20%281%29.png";

export default function Footer() {
  return (
    <footer className="bg-[#0F172A] text-slate-300" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <Link to="/" className="inline-block mb-5">
            <div
              className="h-20 w-56 sm:h-24 sm:w-64 rounded-xl bg-no-repeat bg-center"
              style={{ backgroundImage: `url(${LOGO_URL})`, backgroundSize: "230%", backgroundPosition: "center 55%" }}
              aria-label={COMPANY.name}
            />
          </Link>
          <p className="text-sm leading-relaxed text-slate-400 max-w-xs">
            Discreet, white-glove relocation for luxury villas, apartments and offices across Kochi and Kerala. Since 2012.
          </p>
          <div className="flex items-center gap-3 mt-6">
            <a href={COMPANY.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" data-testid="footer-facebook-link" className="w-9 h-9 grid place-items-center rounded-full bg-white/5 hover:bg-[#081537] transition">
              <Facebook className="w-4 h-4" />
            </a>
            <a href={COMPANY.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram-link" className="w-9 h-9 grid place-items-center rounded-full bg-white/5 hover:bg-[#081537] transition">
              <Instagram className="w-4 h-4" />
            </a>
            <a href={buildWhatsAppUrl()} target="_blank" rel="noreferrer" aria-label="WhatsApp" data-testid="footer-whatsapp-link" className="w-9 h-9 grid place-items-center rounded-full bg-white/5 hover:bg-green-500 transition">
              <MessageCircle className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-5 text-sm uppercase tracking-wider">Services</h4>
          <ul className="space-y-3">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.slug}>
                <Link to="/services" className="text-sm text-slate-400 hover:text-slate-300 transition">{s.title}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-5 text-sm uppercase tracking-wider">Top Service Areas</h4>
          <ul className="grid grid-cols-2 gap-2">
            {SERVICE_AREAS_TOP20.slice(0, 12).map((a) => (
              <li key={a} className="text-sm text-slate-400 hover:text-slate-300 transition">
                <Link to="/service-areas">{a}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-5 text-sm uppercase tracking-wider">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-0.5 text-slate-300 flex-shrink-0" />
              <span className="text-slate-400">{COMPANY.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-slate-300 flex-shrink-0" />
              <a href={callUrl} className="text-slate-300 hover:text-slate-300">{COMPANY.phone}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-slate-300 flex-shrink-0" />
              <a href={mailUrl} className="text-slate-300 hover:text-slate-300">{COMPANY.email}</a>
            </li>
          </ul>

          <a
            href={buildWhatsAppUrl()}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-whatsapp-btn"
            className="mt-6 inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white rounded-full px-5 py-2.5 text-sm font-semibold transition"
          >
            <MessageCircle className="w-4 h-4" /> WhatsApp Us
          </a>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</div>
          <div className="flex gap-6">
            <Link to="/about" className="hover:text-slate-300">About</Link>
            <Link to="/services" className="hover:text-slate-300">Services</Link>
            <Link to="/contact" className="hover:text-slate-300">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
